import React,{useState} from 'react'
import {Input} from "antd";
import AppButton from "../../../components/button";
import {nextStage} from "../../../redux/actions";
import {connect} from "react-redux";

const MainnetTab = ({
    stage,
    ...props
}) =>{

    const [deposited,deposit] = useState(false)

    return(
        stage==5?
            <div className={'col center font-lg'}>
                You game has been deployed to Mainnet
            </div>
            :
        deposited?
            setTimeout(()=>props.dispatch(nextStage()),2000) &&
            <div className={'col center font-lg'}>
                50000 TAP Bond Deposited. Deploying to mainnet...
            </div>
            :
        <div className={'col center'}>
        Submit Game to Mainnet
            <br/>
            <br/>
            <h3 className={'primary bold'}>
                50000 TAP Deposit Required
            </h3>
            <br/>
            <Input style={{width:280,textAlign:'center'}} placeholder={'Enter sponsor address'} />
            <br/>
            <br/>
            <div className={'font-lg'}>OR</div>
            <br/>
            <AppButton glow
                       onClick={()=>{
                           deposit(true)
                           // props.dispatch(nextStage())
                       }}
            >
                DEPOSIT TAP BOND
            </AppButton>
        </div>
    )
}

const mapStateToProps = (store) => ({
    stage: store.appReducer.stage

})

export default connect(mapStateToProps)(MainnetTab)